/** Represents the color tone of a foreground element. */
export type ForegroundTone =
  | 'base'
  | 'subtle'
  | 'muted'
  | 'inverse'
  | 'accent'
  | 'info'
  | 'success'
  | 'warning'
  | 'critical';
